const EventEmitter = require('eventemitter3');

import getUnitState from '../../../isomorphic-helpers/getUnitState';
const BattleCalc = require('../../BattleCalc');
const Dwarf = require('../../../models/game_pieces/ai_units/summoned_units/Dwarf');
const SummonedCondition = require('../../conditions/SummonedCondition');
const { logError } = require('../../logger');
const DeathEvent = require('../../events/DeathEvent');
const { v4: uuidv4 } = require('uuid');

export default function SummonDwarf(battleState) {
  this.handle = 'summon_dwarf';
  this.magic = true;
  this.help = true;

  this.eventEmitter = new EventEmitter();

  this.isLegal = function (actor, victim) {
    return victim.tile && !victim.occupied;
  };

  this.execute = function (actor, victim) {
    if (!actor || !actor.inPlay || !victim) {
      return { success: false };
    }

    try {
      const ability = BattleCalc.getEquippedAbility(actor, this.handle);

      // kill dwarves on the board if above max
      const mySummoned = Object.values(battleState?.allUnits).filter(
        (unit) => unit.handle === 'dwarf' && unit.ownerId === actor.uid
      );
      const max_num_summoned = BattleCalc.getMaxNumSummons({
        ability_handle: ability.handle,
        caster_build: actor,
      });
      if (mySummoned.length + 1 >= max_num_summoned) {
        const num_to_kill = mySummoned.length + 1 - max_num_summoned;
        for (let i = 0; i < num_to_kill; ++i) {
          const random_index = Math.floor(Math.random() * mySummoned.length);
          const [summoned_to_kill] = mySummoned.splice(random_index, 1);
          new DeathEvent(battleState).execute(summoned_to_kill);
        }
      }

      const dwarf = Dwarf(ability.potency, actor);
      dwarf.ability_trees = dwarf.getAbilityTrees();
      dwarf.attributes = { base: dwarf.getBaseAttributes() };
      const dwarf_unit_state = getUnitState({ ai_unit: dwarf });
      dwarf_unit_state.uid = uuidv4();
      dwarf_unit_state.ownerId = actor.uid;
      dwarf_unit_state.x = victim.x;
      dwarf_unit_state.y = victim.y;

      for (const prop in dwarf_unit_state.equipment) {
        dwarf_unit_state.equipment[prop].tint = 0xf2c9b8; // 0x743333;
      }

      battleState.registerNewUnit(dwarf_unit_state);
      battleState.onUnitCondition(
        new SummonedCondition(actor, dwarf_unit_state, battleState, ability.duration)
      );

      const result = { dwarf: dwarf_unit_state };
      result.abilityHandle = this.handle;
      result.actorId = actor.uid;
      result.victimId = victim.uid;
      result.allPieces = battleState.allPieces;
      this.eventEmitter.emit('result', result);
    } catch (err) {
      logError(err, {
        module: 'SummonDwarf',
        func: 'execute',
        actor,
        victim,
      });
      return { success: false };
    }
  };
};
